// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/make-life-easy-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/blue_circle-tick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/images/circle-tick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/images/redCircle_icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

.cmsPages-layout {
  padding-top: 156px;
}
@media (max-width: 899px) {
  .cmsPages-layout {
    padding-top: 85px;
  }
}
.cmsPages-layout .cms-inner {
  padding-top: 80px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner {
    padding-top: 30px;
  }
  .cmsPages-layout .cms-inner h2 {
    font-size: 1.875rem;
    line-height: 45px;
  }
  .cmsPages-layout .cms-inner h4 {
    font-size: 1.25rem;
    line-height: 30px;
  }
}
.cmsPages-layout .cms-inner p {
  color: rgb(37, 37, 37);
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .mb-margin1 {
    margin-bottom: 40px !important;
  }
  .cmsPages-layout .cms-inner .mb-margin2 {
    margin-bottom: 24px !important;
  }
}
.cmsPages-layout .cms-inner .points_list li {
  font-weight: 400;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 21px;
  color: rgb(37, 37, 37);
  text-align: justify;
}
.cmsPages-layout .cms-inner .points_list li:last-child {
  margin-bottom: 0;
}
.cmsPages-layout .cms-inner .points_list li span {
  font-weight: 500;
}
.cmsPages-layout .cms-inner .contact-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .contact-section h4 {
  margin-bottom: 10px;
  margin-top: 24px;
  font-size: 1.25rem;
}
.cmsPages-layout .cms-inner .contact-section p {
  color: rgb(89, 89, 89);
}
.cmsPages-layout .cms-inner .contact-section .formBox {
  border-radius: 12px;
  padding: 20px 8px;
  background: #E9F1FD;
}
.cmsPages-layout .cms-inner .contact-section .formBox .mailP {
  font-weight: 500;
  color: rgb(34, 34, 34);
}
.cmsPages-layout .cms-inner .contact-section .formBox .mailP a {
  display: block;
  word-break: break-all;
  color: rgb(89, 89, 89);
  font-weight: 400;
}
.cmsPages-layout .cms-inner .map-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .privacypolicy-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .terms-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .services-header-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center bottom/100%;
  margin-bottom: 80px;
  padding-bottom: 60px;
}
.cmsPages-layout .cms-inner .services-list-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .services-list-section .services_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .services-list-section .services_list {
    gap: 16px;
  }
}
.cmsPages-layout .cms-inner .services-list-section .services_list li {
  width: calc(50% - 12px);
  border-radius: 12px;
  padding: 24px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);
}
.cmsPages-layout .cms-inner .services-list-section .services_list li:nth-child(odd):last-child {
  width: 100%;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .services-list-section .services_list li {
    width: 100%;
  }
}
@media (max-width: 499px) {
  .cmsPages-layout .cms-inner .services-list-section .services_list li {
    padding: 16px;
  }
}
.cmsPages-layout .cms-inner .services-list-section .services_list li h6 {
  font-weight: 500;
  margin-bottom: 12px;
}
.cmsPages-layout .cms-inner .services-list-section .services_list li p {
  color: rgb(89, 89, 89);
}
.cmsPages-layout .cms-inner .sectors-list-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .sectors-list-section .sectors_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .sectors-list-section .sectors_list {
    gap: 16px;
  }
}
.cmsPages-layout .cms-inner .sectors-list-section .sectors_list li {
  width: calc(50% - 12px);
  border-radius: 12px;
  padding: 24px;
  background: #E9F1FD;
}
.cmsPages-layout .cms-inner .sectors-list-section .sectors_list li:nth-child(odd):last-child {
  width: 100%;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .sectors-list-section .sectors_list li {
    width: 100%;
  }
}
@media (max-width: 499px) {
  .cmsPages-layout .cms-inner .sectors-list-section .sectors_list li {
    padding: 16px;
  }
}
.cmsPages-layout .cms-inner .sectors-list-section .sectors_list li h6 {
  font-weight: 500;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  word-break: break-word;
}
.cmsPages-layout .cms-inner .whychoose-list-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list {
    gap: 16px;
  }
}
.cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li {
  width: calc(50% - 12px);
  border-radius: 12px;
  padding: 24px;
}
.cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li:nth-child(odd):last-child {
  width: 100%;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li {
    width: 100%;
  }
}
@media (max-width: 499px) {
  .cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li {
    padding: 16px;
  }
}
.cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li h4 {
  font-size: 20px;
  margin-bottom: 12px;
  color: rgb(89, 89, 89);
}
.cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li h6 {
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 12px;
}
.cmsPages-layout .cms-inner .whychoose-list-section .whychoose_list li hr {
  border: none;
  border-top: 1px solid rgb(224, 224, 224);
  margin-bottom: 24px;
}
.cmsPages-layout .cms-inner .amaze-differnce-section {
  margin-bottom: 80px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .amaze-differnce-section h2,
  .cmsPages-layout .cms-inner .amaze-differnce-section p {
    text-align: center;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-root {
  min-height: 30px;
  padding: 0 12px;
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-scroller {
  display: flex;
  justify-content: center;
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-flexContainer {
  justify-content: center;
  outline: 1px solid #1E2E5F;
  outline-offset: -1px;
  display: inline-flex;
  border-radius: 20px;
  overflow: hidden;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-flexContainer {
    outline: none;
    border-radius: none;
    flex-wrap: wrap;
    gap: 8px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-flexContainer .MuiTab-root {
  padding: 10px 20px;
  min-height: auto;
  font-family: "poppins";
  font-size: 1rem;
  line-height: 24px;
  text-transform: capitalize;
  color: #000000;
  font-weight: 400;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-flexContainer .MuiTab-root {
    outline: 1px solid #1E2E5F;
    outline-offset: -1px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 20px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-flexContainer .MuiTab-root.Mui-selected {
  background: #1E2E5F;
  color: #ffffff;
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabs-indicator {
  display: none;
}
.cmsPages-layout .cms-inner .aboutsus-section .MuiTabPanel-root {
  padding: 0 !important;
  padding-top: 80px !important;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .MuiTabPanel-root {
    padding-top: 40px !important;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li {
  margin-bottom: 20px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li:last-child {
  margin-bottom: 0;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li .li_inner {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 0.875rem;
  line-height: 21px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li .li_inner img {
  min-width: 28px;
  height: 30px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li .subList {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  padding-left: 46px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li .subList li {
  width: calc(50% - 5px);
  position: relative;
  padding-left: 20px;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 21px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li .subList li:before {
  position: absolute;
  top: calc(50% - 5px);
  left: 0;
  width: 10px;
  height: 10px;
  background: #E9F1FD;
  border-radius: 50%;
  content: " ";
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .comp_sec_section .abt_desc_list li .subList li:nth-child(odd):last-child {
  width: 100%;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section {
  margin-bottom: 80px;
  padding: 24px 0;
  background: #E9F1FD;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list {
  width: 100%;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multiple-carousel__arrow {
  background: rgba(30, 113, 236, 0.1);
  min-height: 36px;
  height: 36px;
  min-width: 36px;
  width: 36px;
  bottom: 0px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multiple-carousel__arrow:before {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multiple-carousel__arrow:hover {
  background: #1E2E5F;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multiple-carousel__arrow:hover:before {
  color: #ffffff;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multiple-carousel__arrow.react-multiple-carousel__arrow--left {
  left: calc(50% - 50px);
  z-index: 2;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multiple-carousel__arrow.react-multiple-carousel__arrow--right {
  right: calc(50% - 50px);
  z-index: 2;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multi-carousel-dot-list {
  bottom: 5px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multi-carousel-dot button {
  border: 1px solid #000000;
  background: #ffffff;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .react-multi-carousel-list .react-multi-carousel-dot--active button {
  border: 1px solid #000000;
  background: #000000;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .productCard {
  padding: 12px 12px 60px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .productCard .inner {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 6px 12px rgba(30, 46, 95, 0.1);
  padding: 24px 12px;
  min-height: 250px;
  text-align: center;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .productCard .inner img {
  height: 120px;
  margin: auto;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .productCard .inner h4 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 8px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .expertise_section .productCard .inner p {
  font-size: 0.875rem;
  line-height: 26px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .vision_mission_section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .vision_mission_section h5 {
  margin-bottom: 8px;
  font-weight: 600;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .vision_mission_section .bluecircle_ticklist li {
  margin-bottom: 20px;
  position: relative;
  font-size: 0.875rem;
  line-height: 21px;
  color: rgb(34, 34, 34);
  padding-left: 21px !important;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .vision_mission_section .bluecircle_ticklist li:before {
  content: "";
  position: absolute;
  top: 2px !important;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 0 0/16px !important;
  width: 16px !important;
  height: 16px !important;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .vision_mission_section .bluecircle_ticklist li:last-child {
  margin-bottom: 0;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section {
  margin-bottom: 80px;
  padding: 40px 0;
  background: #E9F1FD;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section ul {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  counter-reset: li-counter;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section ul {
    gap: 12px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section ul li {
  border-radius: 10px;
  padding: 24px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);
  width: calc(33.3333333333% - 16px);
  min-height: 90px;
  min-width: 300px;
  background: #ffffff;
  display: flex;
  gap: 12px;
  align-items: center;
  text-align: left;
  font-size: 14px;
  line-height: 21px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section ul li {
    padding: 16px 12px;
    flex: 1 1;
  }
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section ul li {
    gap: 12px;
    min-height: auto;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .ethics_section ul li span {
  color: #BE2532;
  font-size: 14px;
  font-weight: 500;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section h4 {
  font-size: 20px;
  line-height: 30px;
  text-align: center;
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section .qps_box {
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 6px 12px 0 rgba(30, 46, 95, 0.12);
  display: flex;
  gap: 24px;
  align-items: center;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section .qps_box {
    gap: 12px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section .qps_box img {
  max-width: 150px;
  width: 100%;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section .qps_box img {
    max-width: 100px;
  }
  .cmsPages-layout .cms-inner .aboutsus-section .aboutusTab .quality_policy_section .qps_box p {
    font-size: 12px;
    line-height: 18px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox {
  padding: 30px 0px;
  margin-bottom: 80px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox {
    margin-bottom: 40px;
    padding: 20px 0;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox:last-child {
  margin-bottom: 0;
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox:nth-child(even) {
  background: #E9F1FD;
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox h4 {
  font-size: 20px;
  line-height: 30px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox h4 {
    text-align: center;
  }
  .cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox p {
    text-align: center;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox .personnel_img {
  width: 100%;
  max-width: 380px;
  margin: auto;
  border-radius: 20px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox .personnel_img {
    max-width: 280px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox .name {
  color: #BE2532;
  margin-bottom: 10px;
}
.cmsPages-layout .cms-inner .aboutsus-section .mgmtPersonnelTab .profileBox .designation {
  margin-bottom: 20px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab h4 {
  font-size: 20px;
  line-height: 30px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .circle_ticklist li {
  margin-bottom: 20px;
  position: relative;
  font-size: 0.875rem;
  line-height: 21px;
  color: rgb(34, 34, 34);
  padding-left: 21px !important;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .circle_ticklist li:before {
  content: "";
  position: absolute;
  top: 2px !important;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 0 0/16px !important;
  width: 16px !important;
  height: 16px !important;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .circle_ticklist li:last-child {
  margin-bottom: 0;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .redcircle_ticklist li {
  margin-bottom: 20px;
  position: relative;
  font-size: 0.875rem;
  line-height: 21px;
  color: #000000;
  padding-left: 34px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .redcircle_ticklist li:before {
  content: "";
  position: absolute;
  top: -2px;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 0 0/22px;
  width: 22px;
  height: 30px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .redcircle_ticklist li:last-child {
  margin-bottom: 0;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox {
  padding: 30px 0px;
  margin-bottom: 80px;
  background: #E9F1FD;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox {
    margin-bottom: 40px;
    padding: 20px 0;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox h4 {
  font-size: 20px;
  line-height: 30px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox h4 {
    text-align: center;
  }
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox p {
    text-align: center;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox .personnel_img {
  width: 100%;
  max-width: 380px;
  margin: auto;
  border-radius: 20px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox .personnel_img {
    max-width: 280px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox .name {
  color: #BE2532;
  margin-bottom: 10px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .profileBox .designation {
  margin-bottom: 10px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .achievements_sec {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .prof_endeavors_sec {
  margin-bottom: 80px;
  background: #E9F1FD;
  padding: 30px 0;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .prof_endeavors_sec {
    margin-bottom: 40px;
    padding: 20px 0;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul {
    gap: 12px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul li {
  border-radius: 10px;
  padding: 24px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);
  text-align: center;
  width: calc(25% - 18px);
  min-height: 180px;
  min-width: 200px;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul li {
    min-width: 160px;
    padding: 16px 12px;
    flex: 1 1;
  }
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul li {
    gap: 12px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul li img {
  margin: 0 auto 16px;
  width: 60px;
  height: 60px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .sector_exp_sector ul li p {
  word-break: break-all;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections {
  margin-bottom: 80px;
  background: #E9F1FD;
  padding: 40px 0px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul {
    gap: 12px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li {
  border-radius: 10px;
  padding: 24px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);
  text-align: center;
  width: calc(33.3333333333% - 16px);
  min-height: 318px;
  min-width: 300px;
  background: #ffffff;
}
@media (max-width: 899px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li {
    padding: 16px 12px;
    flex: 1 1;
  }
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li {
    gap: 12px;
    min-height: auto;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li img {
  margin: 0 auto 10px;
  width: 136px;
  height: 136;
}
@media (max-width: 699px) {
  .cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li img {
    width: 90px;
    height: 90px;
  }
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li h4 {
  margin-bottom: 10px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .client_solution_sections ul li p {
  word-break: break-all;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .journey_section {
  margin-bottom: 80px;
}
.cmsPages-layout .cms-inner .aboutsus-section .managingDirectorTab .journey_section p span {
  font-weight: 600;
  color: #BE2532;
  font-size: 1rem;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/SCSS/Mixins.scss","webpack://./src/SCSS/CMSPages.scss"],"names":[],"mappings":"AAWA,yCAAA;AAoDI;EACI,2BAAA;AC7DR;;ADgEI;EACI,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;AC7DR;;ADgEI;EACI,6BAAA;AC7DR;;ADgEI;EACI,2BAAA;EACA,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;EACA,6BAAA;AC7DR;;ADsCI;EACI,2BAAA;ACnCR;;ADsCI;EACI,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;ACnCR;;ADsCI;EACI,6BAAA;ACnCR;;ADsCI;EACI,2BAAA;EACA,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;EACA,6BAAA;ACnCR;;ADYI;EACI,2BAAA;ACTR;;ADYI;EACI,4BAAA;ACTR;;ADYI;EACI,0BAAA;ACTR;;ADYI;EACI,6BAAA;ACTR;;ADYI;EACI,2BAAA;EACA,4BAAA;ACTR;;ADYI;EACI,0BAAA;EACA,6BAAA;ACTR;;ADdI;EACI,4BAAA;ACiBR;;ADdI;EACI,6BAAA;ACiBR;;ADdI;EACI,2BAAA;ACiBR;;ADdI;EACI,8BAAA;ACiBR;;ADdI;EACI,4BAAA;EACA,6BAAA;ACiBR;;ADdI;EACI,2BAAA;EACA,8BAAA;ACiBR;;ADxCI;EACI,4BAAA;AC2CR;;ADxCI;EACI,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;AC2CR;;ADxCI;EACI,8BAAA;AC2CR;;ADxCI;EACI,4BAAA;EACA,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;EACA,8BAAA;AC2CR;;ADlEI;EACI,4BAAA;ACqER;;ADlEI;EACI,6BAAA;ACqER;;ADlEI;EACI,2BAAA;ACqER;;ADlEI;EACI,8BAAA;ACqER;;ADlEI;EACI,4BAAA;EACA,6BAAA;ACqER;;ADlEI;EACI,2BAAA;EACA,8BAAA;ACqER;;AD5FI;EACI,4BAAA;AC+FR;;AD5FI;EACI,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;AC+FR;;AD5FI;EACI,8BAAA;AC+FR;;AD5FI;EACI,4BAAA;EACA,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;EACA,8BAAA;AC+FR;;ADtHI;EACI,4BAAA;ACyHR;;ADtHI;EACI,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;ACyHR;;ADtHI;EACI,8BAAA;ACyHR;;ADtHI;EACI,4BAAA;EACA,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;EACA,8BAAA;ACyHR;;ADhJI;EACI,4BAAA;ACmJR;;ADhJI;EACI,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;ACmJR;;ADhJI;EACI,8BAAA;ACmJR;;ADhJI;EACI,4BAAA;EACA,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;EACA,8BAAA;ACmJR;;AD1KI;EACI,4BAAA;AC6KR;;AD1KI;EACI,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;AC6KR;;AD1KI;EACI,8BAAA;AC6KR;;AD1KI;EACI,4BAAA;EACA,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;EACA,8BAAA;AC6KR;;ADpMI;EACI,4BAAA;ACuMR;;ADpMI;EACI,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;ACuMR;;ADpMI;EACI,8BAAA;ACuMR;;ADpMI;EACI,4BAAA;EACA,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;EACA,8BAAA;ACuMR;;AD9NI;EACI,4BAAA;ACiOR;;AD9NI;EACI,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;ACiOR;;AD9NI;EACI,8BAAA;ACiOR;;AD9NI;EACI,4BAAA;EACA,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;EACA,8BAAA;ACiOR;;ADxPI;EACI,4BAAA;AC2PR;;ADxPI;EACI,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;AC2PR;;ADxPI;EACI,8BAAA;AC2PR;;ADxPI;EACI,4BAAA;EACA,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;EACA,8BAAA;AC2PR;;ADlRI;EACI,4BAAA;ACqRR;;ADlRI;EACI,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;ACqRR;;ADlRI;EACI,8BAAA;ACqRR;;ADlRI;EACI,4BAAA;EACA,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;EACA,8BAAA;ACqRR;;AD5SI;EACI,4BAAA;AC+SR;;AD5SI;EACI,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;AC+SR;;AD5SI;EACI,8BAAA;AC+SR;;AD5SI;EACI,4BAAA;EACA,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;EACA,8BAAA;AC+SR;;ADtUI;EACI,4BAAA;ACyUR;;ADtUI;EACI,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;ACyUR;;ADtUI;EACI,8BAAA;ACyUR;;ADtUI;EACI,4BAAA;EACA,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;EACA,8BAAA;ACyUR;;ADhWI;EACI,4BAAA;ACmWR;;ADhWI;EACI,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;ACmWR;;ADhWI;EACI,8BAAA;ACmWR;;ADhWI;EACI,4BAAA;EACA,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;EACA,8BAAA;ACmWR;;AD1XI;EACI,4BAAA;AC6XR;;AD1XI;EACI,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;AC6XR;;AD1XI;EACI,8BAAA;AC6XR;;AD1XI;EACI,4BAAA;EACA,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;EACA,8BAAA;AC6XR;;ADpZI;EACI,4BAAA;ACuZR;;ADpZI;EACI,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;ACuZR;;ADpZI;EACI,8BAAA;ACuZR;;ADpZI;EACI,4BAAA;EACA,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;EACA,8BAAA;ACuZR;;AD9aI;EACI,4BAAA;ACibR;;AD9aI;EACI,6BAAA;ACibR;;AD9aI;EACI,2BAAA;ACibR;;AD9aI;EACI,8BAAA;ACibR;;AD9aI;EACI,4BAAA;EACA,6BAAA;ACibR;;AD9aI;EACI,2BAAA;EACA,8BAAA;ACibR;;AD3aI;EACI,4BAAA;AC8aR;;AD3aI;EACI,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;AC8aR;;AD3aI;EACI,8BAAA;AC8aR;;AD3aI;EACI,4BAAA;EACA,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;EACA,8BAAA;AC8aR;;ADrcI;EACI,4BAAA;ACwcR;;ADrcI;EACI,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;ACwcR;;ADrcI;EACI,8BAAA;ACwcR;;ADrcI;EACI,4BAAA;EACA,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;EACA,8BAAA;ACwcR;;AD/dI;EACI,4BAAA;ACkeR;;AD/dI;EACI,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;ACkeR;;AD/dI;EACI,8BAAA;ACkeR;;AD/dI;EACI,4BAAA;EACA,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;EACA,8BAAA;ACkeR;;ADzfI;EACI,6BAAA;AC4fR;;ADzfI;EACI,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;AC4fR;;ADzfI;EACI,+BAAA;AC4fR;;ADzfI;EACI,6BAAA;EACA,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;EACA,+BAAA;AC4fR;;ADnhBI;EACI,6BAAA;ACshBR;;ADnhBI;EACI,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;ACshBR;;ADnhBI;EACI,+BAAA;ACshBR;;ADnhBI;EACI,6BAAA;EACA,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;EACA,+BAAA;ACshBR;;AD7iBI;EACI,6BAAA;ACgjBR;;AD7iBI;EACI,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;ACgjBR;;AD7iBI;EACI,+BAAA;ACgjBR;;AD7iBI;EACI,6BAAA;EACA,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;EACA,+BAAA;ACgjBR;;ADvkBI;EACI,6BAAA;AC0kBR;;ADvkBI;EACI,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;AC0kBR;;ADvkBI;EACI,+BAAA;AC0kBR;;ADvkBI;EACI,6BAAA;EACA,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;EACA,+BAAA;AC0kBR;;ADjmBI;EACI,6BAAA;AComBR;;ADjmBI;EACI,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;AComBR;;ADjmBI;EACI,+BAAA;AComBR;;ADjmBI;EACI,6BAAA;EACA,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;EACA,+BAAA;AComBR;;AD3nBI;EACI,6BAAA;AC8nBR;;AD3nBI;EACI,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;AC8nBR;;AD3nBI;EACI,+BAAA;AC8nBR;;AD3nBI;EACI,6BAAA;EACA,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;EACA,+BAAA;AC8nBR;;ADrpBI;EACI,6BAAA;ACwpBR;;ADrpBI;EACI,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;ACwpBR;;ADrpBI;EACI,+BAAA;ACwpBR;;ADrpBI;EACI,6BAAA;EACA,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;EACA,+BAAA;ACwpBR;;AD/qBI;EACI,6BAAA;ACkrBR;;AD/qBI;EACI,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;ACkrBR;;AD/qBI;EACI,+BAAA;ACkrBR;;AD/qBI;EACI,6BAAA;EACA,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;EACA,+BAAA;ACkrBR;;ADzsBI;EACI,6BAAA;AC4sBR;;ADzsBI;EACI,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;AC4sBR;;ADzsBI;EACI,+BAAA;AC4sBR;;ADzsBI;EACI,6BAAA;EACA,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;EACA,+BAAA;AC4sBR;;ADnuBI;EACI,6BAAA;ACsuBR;;ADnuBI;EACI,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;ACsuBR;;ADnuBI;EACI,+BAAA;ACsuBR;;ADnuBI;EACI,6BAAA;EACA,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;EACA,+BAAA;ACsuBR;;AD7vBI;EACI,6BAAA;ACgwBR;;AD7vBI;EACI,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;ACgwBR;;AD7vBI;EACI,+BAAA;ACgwBR;;AD7vBI;EACI,6BAAA;EACA,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;EACA,+BAAA;ACgwBR;;ADvxBI;EACI,6BAAA;AC0xBR;;ADvxBI;EACI,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;AC0xBR;;ADvxBI;EACI,+BAAA;AC0xBR;;ADvxBI;EACI,6BAAA;EACA,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;EACA,+BAAA;AC0xBR;;ADjzBI;EACI,6BAAA;ACozBR;;ADjzBI;EACI,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;ACozBR;;ADjzBI;EACI,+BAAA;ACozBR;;ADjzBI;EACI,6BAAA;EACA,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;EACA,+BAAA;ACozBR;;AD30BI;EACI,6BAAA;AC80BR;;AD30BI;EACI,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;AC80BR;;AD30BI;EACI,+BAAA;AC80BR;;AD30BI;EACI,6BAAA;EACA,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;EACA,+BAAA;AC80BR;;ADr2BI;EACI,6BAAA;ACw2BR;;ADr2BI;EACI,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;ACw2BR;;ADr2BI;EACI,+BAAA;ACw2BR;;ADr2BI;EACI,6BAAA;EACA,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;EACA,+BAAA;ACw2BR;;AD/3BI;EACI,6BAAA;ACk4BR;;AD/3BI;EACI,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;ACk4BR;;AD/3BI;EACI,+BAAA;ACk4BR;;AD/3BI;EACI,6BAAA;EACA,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;EACA,+BAAA;ACk4BR;;ADz5BI;EACI,6BAAA;AC45BR;;ADz5BI;EACI,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;AC45BR;;ADz5BI;EACI,+BAAA;AC45BR;;ADz5BI;EACI,6BAAA;EACA,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;EACA,+BAAA;AC45BR;;AA7gCA;EACI,kBAAA;AAghCJ;AA9gCI;EAHJ;IAIQ,iBAAA;EAihCN;AACF;AA/gCI;EACI,iBAAA;AAihCR;AA/gCQ;EAHJ;IAIQ,iBAAA;EAkhCV;EA/gCM;IDqBJ,mBAAA;IClBY,iBAAA;EAkhCd;EA9gCM;IDcJ,kBAAA;ICXY,iBAAA;EAihCd;AAXF;AAlgCQ;EACI,sBAAA;AAghCZ;AA5gCY;EADJ;IAEQ,8BAAA;EA+gCd;EA3gCM;IAEQ,8BAAA;EA8gCd;AAJF;AArgCY;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AA4gChB;AA1gCgB;EACI,gBAAA;AA4gCpB;AAzgCgB;EACI,gBAAA;AA2gCpB;AArgCQ;EACI,mBAAA;AAugCZ;AArgCY;EACI,mBAAA;EACA,gBAAA;EDlCZ,kBAAA;AC0iCJ;AApgCY;EACI,sBAAA;AAsgChB;AAngCY;EACI,mBAAA;EACA,iBAAA;EACA,mBD1EL;AC+kCX;AAngCgB;EACI,gBAAA;EACA,sBAAA;AAqgCpB;AAngCoB;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAqgCxB;AA//BQ;EACI,mBAAA;AAigCZ;AA7/BQ;EACI,mBAAA;AA+/BZ;AA5/BQ;EACI,mBAAA;AA8/BZ;AA1/BQ;EACI,gFAAA;EACA,mBAAA;EACA,oBAAA;AA4/BZ;AAz/BQ;EACI,mBAAA;AA2/BZ;AAz/BY;EACI,aAAA;EACA,eAAA;EACA,SAAA;AA2/BhB;AAz/BgB;EALJ;IAMQ,SAAA;EA4/BlB;AACF;AA1/BgB;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,qDAAA;AA4/BpB;AAz/BwB;EACI,WAAA;AA2/B5B;AAv/BoB;EAZJ;IAaQ,WAAA;EA0/BtB;AACF;AAx/BoB;EAhBJ;IAiBQ,aAAA;EA2/BtB;AACF;AAz/BoB;EACI,gBAAA;EACA,mBAAA;AA2/BxB;AAx/BoB;EACI,sBAAA;AA0/BxB;AAn/BQ;EACI,mBAAA;AAq/BZ;AAn/BY;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAq/BhB;AAn/BgB;EALJ;IAMQ,SAAA;EAs/BlB;AACF;AAp/BgB;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBD3KT;ACiqCX;AAn/BwB;EACI,WAAA;AAq/B5B;AAj/BoB;EAZJ;IAaQ,WAAA;EAo/BtB;AACF;AAl/BoB;EAhBJ;IAiBQ,aAAA;EAq/BtB;AACF;AAn/BoB;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AAq/BxB;AA9+BQ;EACI,mBAAA;AAg/BZ;AA9+BY;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAg/BhB;AA9+BgB;EALJ;IAMQ,SAAA;EAi/BlB;AACF;AA/+BgB;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;AAi/BpB;AA9+BwB;EACI,WAAA;AAg/B5B;AA5+BoB;EAXJ;IAYQ,WAAA;EA++BtB;AACF;AA7+BoB;EAfJ;IAgBQ,aAAA;EAg/BtB;AACF;AA9+BoB;EACI,eAAA;EACA,mBAAA;EACA,sBAAA;AAg/BxB;AA7+BoB;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA++BxB;AA5+BoB;EACI,YAAA;EACA,wCAAA;EACA,mBAAA;AA8+BxB;AAx+BQ;EACI,mBAAA;AA0+BZ;AAt+BgB;EAFJ;;IAGQ,kBAAA;EA0+BlB;AACF;AAr+BQ;EACI,mBAAA;AAu+BZ;AAr+BY;EACI,gBAAA;EACA,eAAA;AAu+BhB;AAp+BY;EACI,aAAA;EACA,uBAAA;AAs+BhB;AAn+BY;EACI,uBAAA;EACA,0BAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAq+BhB;AAn+BgB;EARJ;IASQ,aAAA;IACA,mBAAA;IACA,eAAA;IACA,QAAA;EAs+BlB;AACF;AAp+BgB;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;ED3QhB,eAAA;EC6QgB,iBAAA;EACA,0BAAA;EACA,cDjTZ;ECkTY,gBAAA;AAs+BpB;AAp+BoB;EAVJ;IAWQ,0BAAA;IACA,oBAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;EAu+BtB;AACF;AAr+BoB;EACI,mBD/Td;ECgUc,cD7ThB;ACoyCR;AAl+BY;EACI,aAAA;AAo+BhB;AAj+BY;EACI,qBAAA;EACA,4BAAA;AAm+BhB;AAj+BgB;EAJJ;IAKQ,4BAAA;EAo+BlB;AACF;AA99BwB;EACI,mBAAA;AAg+B5B;AA99B4B;EACI,gBAAA;AAg+BhC;AA79B4B;EACI,aAAA;EACA,mBAAA;EACA,SAAA;ED3T5B,mBAAA;EC6T4B,iBAAA;AA+9BhC;AA79BgC;EACI,eAAA;EACA,YAAA;AA+9BpC;AAz9B4B;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AA29BhC;AAz9BgC;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EDlVhC,mBAAA;ECoVgC,iBAAA;AA29BpC;AAz9BoC;ED9UhC,kBC+UsD;ED9UtD,oBC8UsE;ED3UtE,OC2U8F;EAC1D,WAAA;EACA,YAAA;EACA,mBDvX7B;ECwX6B,kBAAA;EACA,YAAA;AA69BxC;AAz9BwC;EACI,WAAA;AA29B5C;AAl9BgB;EACI,mBAAA;EACA,eAAA;EACA,mBD1YT;AC81CX;AAl9BoB;EACI,WAAA;AAo9BxB;AAj9BwB;EACI,mCAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;AAm9B5B;AAj9B4B;EACI,cD9ZxB;EC+ZwB,eAAA;EACA,gBAAA;AAm9BhC;AAh9B4B;EACI,mBDtatB;ACw3CV;AAh9BgC;EACI,cDta5B;ACw3CR;AA98B4B;EACI,sBAAA;EACA,UAAA;AAg9BhC;AA78B4B;EACI,uBAAA;EACA,UAAA;AA+8BhC;AA38BwB;EACI,WAAA;AA68B5B;AA18BwB;EACI,yBAAA;EACA,mBD3bpB;ACu4CR;AAz8BwB;EACI,yBAAA;EACA,mBDjcpB;AC44CR;AAv8BoB;EACI,uBAAA;AAy8BxB;AAv8BwB;EACI,mBDxcpB;EAiBJ,mBCwb+C;ED9b/C,8CC+b4C;EACpB,kBAAA;EACA,iBAAA;EACA,kBAAA;AA68B5B;AA38B4B;EACI,aAAA;EACA,YAAA;AA68BhC;AA18B4B;EDnbxB,kBAAA;ECqb4B,gBAAA;EACA,kBAAA;AA48BhC;AAz8B4B;EDzbxB,mBAAA;EC2b4B,iBAAA;AA28BhC;AAr8BgB;EACI,mBAAA;AAu8BpB;AAr8BoB;EACI,kBAAA;EACA,gBAAA;AAu8BxB;AAn8BwB;EACI,mBAAA;EACA,kBAAA;ED5cxB,mBAAA;EC8cwB,iBAAA;EACA,sBAAA;EACA,6BAAA;AAq8B5B;AAn8B4B;EACI,WAAA;ED3c5B,kBC4c8C;ED3c9C,mBC2c8D;EDxc9D,OCwcqF;EACzD,iFAAA;EACA,sBAAA;EACA,uBAAA;AAu8BhC;AAp8B4B;EACI,gBAAA;AAs8BhC;AAh8BgB;EACI,mBAAA;EACA,eAAA;EACA,mBDjgBT;ACm8CX;AAh8BoB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;AAk8BxB;AAh8BwB;EAPJ;IAQQ,SAAA;EAm8B1B;AACF;AAj8BwB;EACI,mBAAA;EACA,aAAA;EACA,oDAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBDzhBpB;EC0hBoB,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAm8B5B;AAj8B4B;EAfJ;IAiBQ,kBAAA;IACA,SAAA;EAm8B9B;AACF;AAj8B4B;EArBJ;IAsBQ,SAAA;IACA,gBAAA;EAo8B9B;AACF;AAl8B4B;EACI,cD/iBpB;ECgjBoB,eAAA;EACA,gBAAA;AAo8BhC;AA97BgB;EACI,mBAAA;AAg8BpB;AA97BoB;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;AAg8BxB;AA77BoB;EACI,mBAAA;EACA,aAAA;EACA,+CAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AA+7BxB;AA77BwB;EARJ;IASQ,SAAA;EAg8B1B;AACF;AA97BwB;EACI,gBAAA;EACA,WAAA;AAg8B5B;AA97B4B;EAJJ;IAKQ,gBAAA;EAi8B9B;EA77BsB;IAEQ,eAAA;IACA,iBAAA;EAg8B9B;AALF;AAl7BgB;EACI,iBAAA;EACA,mBAAA;AA07BpB;AAx7BoB;EAJJ;IAKQ,mBAAA;IACA,eAAA;EA27BtB;AACF;AAz7BoB;EACI,gBAAA;AA27BxB;AAx7BoB;EACI,mBDzmBb;ACmiDX;AAv7BoB;EACI,eAAA;EACA,iBAAA;AAy7BxB;AAv7BwB;EAJJ;IAKQ,kBAAA;EA07B1B;EAt7BkB;IAEQ,kBAAA;EAy7B1B;AAJF;AAj7BoB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,oDAAA;AAw7BxB;AAt7BwB;EAPJ;IAQQ,gBAAA;EAy7B1B;AACF;AAt7BoB;EACI,cD9oBZ;EC+oBY,mBAAA;AAw7BxB;AAr7BoB;EACI,mBAAA;AAu7BxB;AAj7BgB;EACI,eAAA;EACA,iBAAA;AAm7BpB;AA/6BoB;EACI,mBAAA;EACA,kBAAA;ED9nBpB,mBAAA;ECgoBoB,iBAAA;EACA,sBAAA;EACA,6BAAA;AAi7BxB;AA/6BwB;EACI,WAAA;ED7nBxB,kBC8nB0C;ED7nB1C,mBC6nB0D;ED1nB1D,OC0nBiF;EACzD,iFAAA;EACA,sBAAA;EACA,uBAAA;AAm7B5B;AAh7BwB;EACI,gBAAA;AAk7B5B;AA56BoB;EACI,mBAAA;EACA,kBAAA;EDrpBpB,mBAAA;ECupBoB,iBAAA;EACA,cD1rBhB;EC2rBgB,kBAAA;AA86BxB;AA56BwB;EACI,WAAA;EDppBxB,kBCqpB0C;EDppB1C,SCopB0D;EDjpB1D,OCipBuE;EAC/C,sEAAA;EACA,WAAA;EACA,YAAA;AAg7B5B;AA76BwB;EACI,gBAAA;AA+6B5B;AA16BgB;EACI,iBAAA;EACA,mBAAA;EACA,mBDzsBT;ACqnDX;AA16BoB;EALJ;IAMQ,mBAAA;IACA,eAAA;EA66BtB;AACF;AA36BoB;EACI,eAAA;EACA,iBAAA;AA66BxB;AA36BwB;EAJJ;IAKQ,kBAAA;EA86B1B;EA16BkB;IAEQ,kBAAA;EA66B1B;AAJF;AAr6BoB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,oDAAA;AA46BxB;AA16BwB;EAPJ;IAQQ,gBAAA;EA66B1B;AACF;AA16BoB;EACI,cDlvBZ;ECmvBY,mBAAA;AA46BxB;AAz6BoB;EACI,mBAAA;AA26BxB;AAv6BgB;EACI,mBAAA;AAy6BpB;AAt6BgB;EACI,mBAAA;EACA,mBD3vBT;EC4vBS,eAAA;AAw6BpB;AAt6BoB;EALJ;IAMQ,mBAAA;IACA,eAAA;EAy6BtB;AACF;AAt6BgB;EACI,mBAAA;AAw6BpB;AAt6BoB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAw6BxB;AAt6BwB;EANJ;IAOQ,SAAA;EAy6B1B;AACF;AAv6BwB;EACI,mBAAA;EACA,aAAA;EACA,oDAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAy6B5B;AAt6B4B;EAVJ;IAWQ,gBAAA;IACA,kBAAA;IACA,SAAA;EAy6B9B;AACF;AAv6B4B;EAhBJ;IAiBQ,SAAA;EA06B9B;AACF;AAx6B4B;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AA06BhC;AAv6B4B;EACI,qBAAA;AAy6BhC;AAn6BgB;EACI,mBAAA;EACA,mBDpzBT;ECqzBS,iBAAA;AAq6BpB;AAn6BoB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAq6BxB;AAn6BwB;EANJ;IAOQ,SAAA;EAs6B1B;AACF;AAp6BwB;EACI,mBAAA;EACA,aAAA;EACA,oDAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBD70BpB;ACmvDR;AAp6B4B;EAVJ;IAYQ,kBAAA;IACA,SAAA;EAs6B9B;AACF;AAp6B4B;EAhBJ;IAiBQ,SAAA;IACA,gBAAA;EAu6B9B;AACF;AAr6B4B;EACI,mBAAA;EACA,YAAA;EACA,WAAA;AAu6BhC;AAr6BgC;EALJ;IAMQ,WAAA;IACA,YAAA;EAw6BlC;AACF;AAr6B4B;EACI,mBAAA;AAu6BhC;AAp6B4B;EACI,qBAAA;AAs6BhC;AAh6BgB;EACI,mBAAA;AAk6BpB;AA/5BwB;EACI,gBAAA;EACA,cDx3BhB;EAmCR,eAAA;ECu1BwB,iBAAA;AAi6B5B","sourcesContent":["// Color Variables\n$primary: #1E2E5F;\n$secondary: #BE2532;\n$black: #000000;\n$white: #ffffff;\n$grey: #808080;\n$red: #D9132E;\n$lightbg: #fbfbfb;\n$lightblue:#E9F1FD;\n\n\n/*--------------Mixins------------------*/\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin border-radius($radius: none) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin appearance() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@function calculateRem($size) {\n    $remSize: $size / 16px;\n    @return #{$remSize}rem;\n}\n\n@mixin fontSize($size) {\n    //font-size: $size;\n    font-size: calculateRem($size);\n}\n\n@mixin position($position,\n    $top: null,\n    $right: null,\n    $bottom: null,\n    $left: null) {\n    position: $position;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    // @include abs-position(10px, 10px, auto, auto);\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n// Margins\n@for $i from 0 to 20 {\n    .ml-#{$i} {\n        margin-left: 4px * $i !important;\n    }\n\n    .mr-#{$i} {\n        margin-right: 4px * $i !important;\n    }\n\n    .mt-#{$i} {\n        margin-top: 4px * $i !important;\n    }\n\n    .mb-#{$i} {\n        margin-bottom: 4px * $i !important;\n    }\n\n    .mx-#{$i} {\n        margin-left: 4px * $i !important;\n        margin-right: 4px * $i !important;\n    }\n\n    .my-#{$i} {\n        margin-top: 4px * $i !important;\n        margin-bottom: 4px * $i !important;\n    }\n}\n\n// Paddings\n@for $i from 0 to 20 {\n    .pl-#{$i} {\n        padding-left: 4px * $i !important;\n    }\n\n    .pr-#{$i} {\n        padding-right: 4px * $i !important;\n    }\n\n    .pt-#{$i} {\n        padding-top: 4px * $i !important;\n    }\n\n    .pb-#{$i} {\n        padding-bottom: 4px * $i !important;\n    }\n\n    .px-#{$i} {\n        padding-left: 4px * $i !important;\n        padding-right: 4px * $i !important;\n    }\n\n    .py-#{$i} {\n        padding-top: 4px * $i !important;\n        padding-bottom: 4px * $i !important;\n    }\n}","@import \"./Mixins.scss\";\n\n.cmsPages-layout {\n    padding-top: 156px;\n\n    @media(max-width:899px) {\n        padding-top: 85px;\n    }\n\n    .cms-inner {\n        padding-top: 80px;\n\n        @media(max-width:899px) {\n            padding-top: 30px;\n        }\n\n        h2 {\n            @media(max-width:899px) {\n                @include fontSize(30px);\n                line-height: 45px;\n            }\n        }\n\n        h4 {\n            @media(max-width:899px) {\n                @include fontSize(20px);\n                line-height: 30px;\n            }\n        }\n\n        p {\n            color: rgba(37, 37, 37, 1);\n        }\n\n        .mb-margin1 {\n            @media(max-width:899px) {\n                margin-bottom: 40px !important;\n            }\n        }\n\n        .mb-margin2 {\n            @media(max-width:899px) {\n                margin-bottom: 24px !important;\n            }\n        }\n\n        .points_list {\n            li {\n                font-weight: 400;\n                margin-bottom: 12px;\n                font-size: 14px;\n                line-height: 21px;\n                color: rgba(37, 37, 37, 1);\n                text-align: justify;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n\n                span {\n                    font-weight: 500;\n                }\n            }\n        }\n\n        // contact page css----\n        .contact-section {\n            margin-bottom: 80px;\n\n            h4 {\n                margin-bottom: 10px;\n                margin-top: 24px;\n                @include fontSize(20px);\n            }\n\n            p {\n                color: rgba(89, 89, 89, 1);\n            }\n\n            .formBox {\n                border-radius: 12px;\n                padding: 20px 8px;\n                background: $lightblue;\n\n                .mailP {\n                    font-weight: 500;\n                    color: rgba(34, 34, 34, 1);\n\n                    a {\n                        display: block;\n                        word-break: break-all;\n                        color: rgba(89, 89, 89, 1);\n                        font-weight: 400;\n                    }\n                }\n            }\n        }\n\n        .map-section {\n            margin-bottom: 80px;\n        }\n\n        // pp page scss---\n        .privacypolicy-section {\n            margin-bottom: 80px;\n        }\n\n        .terms-section {\n            margin-bottom: 80px;\n        }\n\n        // ourservices css---\n        .services-header-section {\n            background: url('./../../public/images/make-life-easy-bg.svg')no-repeat center bottom/100%;\n            margin-bottom: 80px;\n            padding-bottom: 60px;\n        }\n\n        .services-list-section {\n            margin-bottom: 80px;\n\n            .services_list {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 24px;\n\n                @media(max-width:699px) {\n                    gap: 16px;\n                }\n\n                li {\n                    width: calc(50% - 12px);\n                    border-radius: 12px;\n                    padding: 24px;\n                    box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);\n\n                    &:nth-child(odd) {\n                        &:last-child {\n                            width: 100%;\n                        }\n                    }\n\n                    @media(max-width:699px) {\n                        width: 100%;\n                    }\n\n                    @media(max-width:499px) {\n                        padding: 16px;\n                    }\n\n                    h6 {\n                        font-weight: 500;\n                        margin-bottom: 12px;\n                    }\n\n                    p {\n                        color: rgba(89, 89, 89, 1);\n                    }\n                }\n            }\n        }\n\n        // our sectors css-----\n        .sectors-list-section {\n            margin-bottom: 80px;\n\n            .sectors_list {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 24px;\n\n                @media(max-width:699px) {\n                    gap: 16px;\n                }\n\n                li {\n                    width: calc(50% - 12px);\n                    border-radius: 12px;\n                    padding: 24px;\n                    background: $lightblue;\n\n                    &:nth-child(odd) {\n                        &:last-child {\n                            width: 100%;\n                        }\n                    }\n\n                    @media(max-width:699px) {\n                        width: 100%;\n                    }\n\n                    @media(max-width:499px) {\n                        padding: 16px;\n                    }\n\n                    h6 {\n                        font-weight: 500;\n                        margin-bottom: 12px;\n                        display: flex;\n                        align-items: center;\n                        gap: 12px;\n                        word-break: break-word;\n                    }\n                }\n            }\n        }\n\n        // why choose us ---\n        .whychoose-list-section {\n            margin-bottom: 80px;\n\n            .whychoose_list {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 24px;\n\n                @media(max-width:699px) {\n                    gap: 16px;\n                }\n\n                li {\n                    width: calc(50% - 12px);\n                    border-radius: 12px;\n                    padding: 24px;\n\n                    &:nth-child(odd) {\n                        &:last-child {\n                            width: 100%;\n                        }\n                    }\n\n                    @media(max-width:699px) {\n                        width: 100%;\n                    }\n\n                    @media(max-width:499px) {\n                        padding: 16px;\n                    }\n\n                    h4 {\n                        font-size: 20px;\n                        margin-bottom: 12px;\n                        color: rgba(89, 89, 89, 1);\n                    }\n\n                    h6 {\n                        font-weight: 500;\n                        display: flex;\n                        align-items: center;\n                        gap: 12px;\n                    }\n\n                    hr {\n                        border: none;\n                        border-top: 1px solid rgba(224, 224, 224, 1);\n                        margin-bottom: 24px;\n                    }\n                }\n            }\n        }\n\n        .amaze-differnce-section {\n            margin-bottom: 80px;\n\n            h2,\n            p {\n                @media(max-width:899px) {\n                    text-align: center;\n                }\n            }\n        }\n\n        // aboutus css---\n        .aboutsus-section {\n            margin-bottom: 80px;\n\n            .MuiTabs-root {\n                min-height: 30px;\n                padding: 0 12px;\n            }\n\n            .MuiTabs-scroller {\n                display: flex;\n                justify-content: center;\n            }\n\n            .MuiTabs-flexContainer {\n                justify-content: center;\n                outline: 1px solid $primary;\n                outline-offset: -1px;\n                display: inline-flex;\n                border-radius: 20px;\n                overflow: hidden;\n\n                @media(max-width:899px) {\n                    outline: none;\n                    border-radius: none;\n                    flex-wrap: wrap;\n                    gap: 8px;\n                }\n\n                .MuiTab-root {\n                    padding: 10px 20px;\n                    min-height: auto;\n                    font-family: 'poppins';\n                    @include fontSize(16px);\n                    line-height: 24px;\n                    text-transform: capitalize;\n                    color: $black;\n                    font-weight: 400;\n\n                    @media(max-width:899px) {\n                        outline: 1px solid $primary;\n                        outline-offset: -1px;\n                        border-radius: 20px;\n                        font-size: 14px;\n                        line-height: 20px;\n                    }\n\n                    &.Mui-selected {\n                        background: $primary;\n                        color: $white;\n                    }\n                }\n            }\n\n            .MuiTabs-indicator {\n                display: none;\n            }\n\n            .MuiTabPanel-root {\n                padding: 0 !important;\n                padding-top: 80px !important;\n\n                @media(max-width:899px) {\n                    padding-top: 40px !important;\n                }\n            }\n\n            .aboutusTab {\n                .comp_sec_section {\n                    .abt_desc_list {\n                        li {\n                            margin-bottom: 20px;\n\n                            &:last-child {\n                                margin-bottom: 0;\n                            }\n\n                            .li_inner {\n                                display: flex;\n                                align-items: center;\n                                gap: 16px;\n                                @include fontSize(14px);\n                                line-height: 21px;\n\n                                img {\n                                    min-width: 28px;\n                                    height: 30px;\n                                }\n                            }\n\n\n\n                            .subList {\n                                display: flex;\n                                flex-wrap: wrap;\n                                gap: 10px;\n                                margin-top: 10px;\n                                padding-left: 46px;\n\n                                li {\n                                    width: calc(50% - 5px);\n                                    position: relative;\n                                    padding-left: 20px;\n                                    margin-bottom: 0;\n                                    @include fontSize(14px);\n                                    line-height: 21px;\n\n                                    &:before {\n                                        @include position(absolute, $top: calc(50% - 5px), $left: 0);\n                                        width: 10px;\n                                        height: 10px;\n                                        background: $lightblue;\n                                        border-radius: 50%;\n                                        content: \" \";\n                                    }\n\n                                    &:nth-child(odd) {\n                                        &:last-child {\n                                            width: 100%;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .expertise_section {\n                    margin-bottom: 80px;\n                    padding: 24px 0;\n                    background: $lightblue;\n\n                    .react-multi-carousel-list {\n                        width: 100%;\n                        // max-width: 1360px;\n\n                        .react-multiple-carousel__arrow {\n                            background: rgba(30, 113, 236, 0.1);\n                            min-height: 36px;\n                            height: 36px;\n                            min-width: 36px;\n                            width: 36px;\n                            bottom: 0px;\n\n                            &:before {\n                                color: $black;\n                                font-size: 14px;\n                                font-weight: 600;\n                            }\n\n                            &:hover {\n                                background: $primary;\n\n                                &:before {\n                                    color: $white;\n                                }\n                            }\n\n                            &.react-multiple-carousel__arrow--left {\n                                left: calc(50% - 50px);\n                                z-index: 2;\n                            }\n\n                            &.react-multiple-carousel__arrow--right {\n                                right: calc(50% - 50px);\n                                z-index: 2;\n                            }\n                        }\n\n                        .react-multi-carousel-dot-list {\n                            bottom: 5px;\n                        }\n\n                        .react-multi-carousel-dot button {\n                            border: 1px solid $black;\n                            background: $white;\n                        }\n\n                        .react-multi-carousel-dot--active button {\n                            border: 1px solid $black;\n                            background: $black;\n                        }\n                    }\n\n                    .productCard {\n                        padding: 12px 12px 60px;\n\n                        .inner {\n                            background: $white;\n                            @include border-radius(12px);\n                            @include box-shadow(0px 6px 12px rgba($primary, 0.1));\n                            padding: 24px 12px;\n                            min-height: 250px;\n                            text-align: center;\n\n                            img {\n                                height: 120px;\n                                margin: auto\n                            }\n\n                            h4 {\n                                @include fontSize(20px);\n                                font-weight: 600;\n                                margin-bottom: 8px;\n                            }\n\n                            p {\n                                @include fontSize(14px);\n                                line-height: 26px;\n                            }\n                        }\n                    }\n                }\n\n                .vision_mission_section {\n                    margin-bottom: 80px;\n\n                    h5 {\n                        margin-bottom: 8px;\n                        font-weight: 600;\n                    }\n\n                    .bluecircle_ticklist {\n                        li {\n                            margin-bottom: 20px;\n                            position: relative;\n                            @include fontSize(14px);\n                            line-height: 21px;\n                            color: rgba(34, 34, 34, 1);\n                            padding-left: 21px !important;\n\n                            &:before {\n                                content: \"\";\n                                @include position(absolute, $top: 2px !important, $left: 0);\n                                background: url(\"./../../public/images/blue_circle-tick.png\")no-repeat 0 0/16px !important;\n                                width: 16px !important;\n                                height: 16px !important;\n                            }\n\n                            &:last-child {\n                                margin-bottom: 0;\n                            }\n                        }\n                    }\n                }\n\n                .ethics_section {\n                    margin-bottom: 80px;\n                    padding: 40px 0;\n                    background: $lightblue;\n\n                    ul {\n                        display: flex;\n                        flex-wrap: wrap;\n                        gap: 24px;\n                        justify-content: center;\n                        counter-reset: li-counter;\n\n                        @media(max-width:699px) {\n                            gap: 12px;\n                        }\n\n                        li {\n                            border-radius: 10px;\n                            padding: 24px;\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);\n                            width: calc((100% / 3) - 16px);\n                            min-height: 90px;\n                            min-width: 300px;\n                            background: $white;\n                            display: flex;\n                            gap: 12px;\n                            align-items: center;\n                            text-align: left;\n                            font-size: 14px;\n                            line-height: 21px;\n\n                            @media(max-width:899px) {\n                                // min-width: 160px;\n                                padding: 16px 12px;\n                                flex: 1;\n                            }\n\n                            @media(max-width:699px) {\n                                gap: 12px;\n                                min-height: auto;\n                            }\n\n                            span {\n                                color: $secondary;\n                                font-size: 14px;\n                                font-weight: 500;\n                            }\n                        }\n                    }\n                }\n\n                .quality_policy_section {\n                    margin-bottom: 80px;\n\n                    h4 {\n                        font-size: 20px;\n                        line-height: 30px;\n                        text-align: center;\n                    }\n\n                    .qps_box {\n                        border-radius: 12px;\n                        padding: 12px;\n                        box-shadow: 0 6px 12px 0 rgba(30, 46, 95, 0.12);\n                        display: flex;\n                        gap: 24px;\n                        align-items: center;\n\n                        @media(max-width:699px) {\n                            gap: 12px;\n                        }\n\n                        img {\n                            max-width: 150px;\n                            width: 100%;\n\n                            @media(max-width:699px) {\n                                max-width: 100px;\n                            }\n                        }\n\n                        p {\n                            @media(max-width:699px) {\n                                font-size: 12px;\n                                line-height: 18px;\n                            }\n                        }\n\n                    }\n                }\n            }\n\n            .mgmtPersonnelTab {\n                .profileBox {\n                    padding: 30px 0px;\n                    margin-bottom: 80px;\n\n                    @media(max-width:899px) {\n                        margin-bottom: 40px;\n                        padding: 20px 0;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n\n                    &:nth-child(even) {\n                        background: $lightblue;\n                    }\n\n                    h4 {\n                        font-size: 20px;\n                        line-height: 30px;\n\n                        @media(max-width:899px) {\n                            text-align: center;\n                        }\n                    }\n\n                    p {\n                        @media(max-width:899px) {\n                            text-align: center;\n                        }\n                    }\n\n                    .personnel_img {\n                        width: 100%;\n                        max-width: 380px;\n                        margin: auto;\n                        border-radius: 20px;\n                        box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);\n\n                        @media(max-width:699px) {\n                            max-width: 280px;\n                        }\n                    }\n\n                    .name {\n                        color: $secondary;\n                        margin-bottom: 10px;\n                    }\n\n                    .designation {\n                        margin-bottom: 20px;\n                    }\n                }\n            }\n\n            .managingDirectorTab {\n                h4 {\n                    font-size: 20px;\n                    line-height: 30px;\n                }\n\n                .circle_ticklist {\n                    li {\n                        margin-bottom: 20px;\n                        position: relative;\n                        @include fontSize(14px);\n                        line-height: 21px;\n                        color: rgba(34, 34, 34, 1);\n                        padding-left: 21px !important;\n\n                        &:before {\n                            content: \"\";\n                            @include position(absolute, $top: 2px !important, $left: 0);\n                            background: url(\"./../../public/images/circle-tick.png\")no-repeat 0 0/16px !important;\n                            width: 16px !important;\n                            height: 16px !important;\n                        }\n\n                        &:last-child {\n                            margin-bottom: 0;\n                        }\n                    }\n                }\n\n                .redcircle_ticklist {\n                    li {\n                        margin-bottom: 20px;\n                        position: relative;\n                        @include fontSize(14px);\n                        line-height: 21px;\n                        color: $black;\n                        padding-left: 34px;\n\n                        &:before {\n                            content: \"\";\n                            @include position(absolute, $top: -2px, $left: 0);\n                            background: url(\"./../../public/images/redCircle_icon.png\")no-repeat 0 0/22px;\n                            width: 22px;\n                            height: 30px;\n                        }\n\n                        &:last-child {\n                            margin-bottom: 0;\n                        }\n                    }\n                }\n\n                .profileBox {\n                    padding: 30px 0px;\n                    margin-bottom: 80px;\n                    background: $lightblue;\n\n                    @media(max-width:899px) {\n                        margin-bottom: 40px;\n                        padding: 20px 0;\n                    }\n\n                    h4 {\n                        font-size: 20px;\n                        line-height: 30px;\n\n                        @media(max-width:899px) {\n                            text-align: center;\n                        }\n                    }\n\n                    p {\n                        @media(max-width:899px) {\n                            text-align: center;\n                        }\n                    }\n\n                    .personnel_img {\n                        width: 100%;\n                        max-width: 380px;\n                        margin: auto;\n                        border-radius: 20px;\n                        box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);\n\n                        @media(max-width:699px) {\n                            max-width: 280px;\n                        }\n                    }\n\n                    .name {\n                        color: $secondary;\n                        margin-bottom: 10px;\n                    }\n\n                    .designation {\n                        margin-bottom: 10px;\n                    }\n                }\n\n                .achievements_sec {\n                    margin-bottom: 80px;\n                }\n\n                .prof_endeavors_sec {\n                    margin-bottom: 80px;\n                    background: $lightblue;\n                    padding: 30px 0;\n\n                    @media(max-width:899px) {\n                        margin-bottom: 40px;\n                        padding: 20px 0;\n                    }\n                }\n\n                .sector_exp_sector {\n                    margin-bottom: 80px;\n\n                    ul {\n                        display: flex;\n                        flex-wrap: wrap;\n                        gap: 24px;\n                        justify-content: center;\n\n                        @media(max-width:699px) {\n                            gap: 12px;\n                        }\n\n                        li {\n                            border-radius: 10px;\n                            padding: 24px;\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);\n                            text-align: center;\n                            width: calc(25% - 18px);\n                            min-height: 180px;\n                            min-width: 200px;\n\n\n                            @media(max-width:899px) {\n                                min-width: 160px;\n                                padding: 16px 12px;\n                                flex: 1;\n                            }\n\n                            @media(max-width:699px) {\n                                gap: 12px;\n                            }\n\n                            img {\n                                margin: 0 auto 16px;\n                                width: 60px;\n                                height: 60px;\n                            }\n\n                            p {\n                                word-break: break-all;\n                            }\n                        }\n                    }\n                }\n\n                .client_solution_sections {\n                    margin-bottom: 80px;\n                    background: $lightblue;\n                    padding: 40px 0px;\n\n                    ul {\n                        display: flex;\n                        flex-wrap: wrap;\n                        gap: 24px;\n                        justify-content: center;\n\n                        @media(max-width:699px) {\n                            gap: 12px;\n                        }\n\n                        li {\n                            border-radius: 10px;\n                            padding: 24px;\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.2);\n                            text-align: center;\n                            width: calc((100% / 3) - 16px);\n                            min-height: 318px;\n                            min-width: 300px;\n                            background: $white;\n\n                            @media(max-width:899px) {\n                                // min-width: 160px;\n                                padding: 16px 12px;\n                                flex: 1;\n                            }\n\n                            @media(max-width:699px) {\n                                gap: 12px;\n                                min-height: auto;\n                            }\n\n                            img {\n                                margin: 0 auto 10px;\n                                width: 136px;\n                                height: 136;\n\n                                @media(max-width:699px) {\n                                    width: 90px;\n                                    height: 90px;\n                                }\n                            }\n\n                            h4 {\n                                margin-bottom: 10px;\n                            }\n\n                            p {\n                                word-break: break-all;\n                            }\n                        }\n                    }\n                }\n\n                .journey_section {\n                    margin-bottom: 80px;\n\n                    p {\n                        span {\n                            font-weight: 600;\n                            color: $secondary;\n                            @include fontSize(16px);\n                            line-height: 24px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
